import { render, staticRenderFns } from "./PasswordWizard.vue?vue&type=template&id=6adcf736"
import script from "./PasswordWizard.vue?vue&type=script&lang=js"
export * from "./PasswordWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports